import { render, staticRenderFns } from "./aboutOurs.vue?vue&type=template&id=34fc8004&scoped=true&"
import script from "./aboutOurs.vue?vue&type=script&lang=js&"
export * from "./aboutOurs.vue?vue&type=script&lang=js&"
import style0 from "./aboutOurs.vue?vue&type=style&index=0&id=34fc8004&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc8004",
  null
  
)

export default component.exports